import type { VistaCard } from "../contratos";

import estilos from "./card.module.css";
import { Bloco, Externo, Frases, Grafico } from "./util";

export function ComoLer({ vista, numero }: { vista: VistaCard; numero: number }) {
  const { armadilha, dado, base } = vista;
  const serie = dado && dado.serie.length > 0 ? dado : null;
  return (
    <Bloco numero={numero} titulo="Como ler estes números">
      {armadilha && (
        <p>
          <strong>{armadilha.titulo}.</strong> {armadilha.explicacao}
        </p>
      )}
      <Frases frases={vista.frases_como_ler} />
      {serie && (
        <figure className={estilos.figura}>
          {vista.graficos.serie && <Grafico svg={vista.graficos.serie} />}
          <table>
            <caption>
              {serie.nome}: valores recentes ({serie.orgao})
            </caption>
            <thead>
              <tr>
                <th scope="col">Período</th>
                <th scope="col">Valor</th>
              </tr>
            </thead>
            <tbody>
              {serie.serie.map((p) => (
                <tr key={p.periodo}>
                  <td>{p.periodo}</td>
                  <td>{p.valor}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </figure>
      )}
      {base && (
        <p>
          Para dar tamanho ao número: {base.nome} ({base.orgao}), {base.periodo}:{" "}
          <strong>{base.valor}</strong>. <Externo href={base.consulta}>Dados brutos</Externo>.
        </p>
      )}
      {!armadilha && !serie && !base && <p>Sem dado oficial, não há números a ler neste card.</p>}
    </Bloco>
  );
}
